/**
 * Vytvoří key pro React z dat z DataSource.
 *
 * @param rowId Identifikátor dat z DataSource.
 */
export const keyGenerator = (rowId: string) => rowId;
